import { useNavigate } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { AGENCY_LOGO_SRC, fileSrc } from "@/lib/api";

export const logoError = (e) => { if (e.currentTarget.src !== AGENCY_LOGO_SRC) e.currentTarget.src = AGENCY_LOGO_SRC; };

export function VerifiedOffice({ className = "" }) {
  const { t } = useI18n();
  return (
    <span data-testid="agency-verified-badge" className={`inline-flex items-center gap-1 rounded-full bg-emerald-50 border border-emerald-200 px-2 py-0.5 text-xs font-bold text-emerald-800 ${className}`}>
      <BadgeCheck className="w-3.5 h-3.5" />{t("agency.verified")}
    </span>
  );
}

export function AgencyLogo({ src, className = "w-8 h-8" }) {
  return <img src={fileSrc(src) || AGENCY_LOGO_SRC} onError={logoError} alt="" loading="lazy" className={`${className} rounded-full object-cover bg-navy border border-line shrink-0`} />;
}

export function AgencyChip({ agency }) {
  const navigate = useNavigate();
  const go = (e) => { e.preventDefault(); e.stopPropagation(); navigate(`/office/${agency.slug}`); };
  return (
    <button type="button" onClick={go} data-testid={`card-agency-link-${agency.slug}`}
      className="flex items-center gap-2 min-w-0 text-start text-xs font-semibold text-navy hover:text-gold transition-colors">
      <AgencyLogo src={agency.logo_url} className="w-6 h-6" />
      <span className="truncate">{agency.name}</span>
      {agency.verified && <BadgeCheck className="w-3.5 h-3.5 text-emerald-700 shrink-0" />}
    </button>
  );
}
